export const baseTransitionTime = 350;

export const transitionKeys = {
  transition: "transition",
  enter: "enter",
  leave: "leave",
  start: "start",
  finish: "finish",
};
